import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';

export type DealTabType = string; 

const tabs: { title: string; key: DealTabType }[] = [
    {
        title: 'All Deals',
        key: 'all',
    },
    {
        title: 'Income',
        key: 'income',
    },
    {
        title: 'Growth',
        key: 'growth',
    },
];

type Props = {
    activeTab: DealTabType;
    setActiveTab: (t: DealTabType) => void;
};

const DealsTabs: React.FC<Props> = ({ activeTab, setActiveTab }) => {
    const deals = useSelector((state: RootState) => state.deal.deals);
    let headlinerTags: { title: string; key: DealTabType }[] = [];
    let tags: string[] = [];
    deals && deals.forEach((d) => {
        if (d.deal && d.deal.dealTags && d.deal.dealTags?.headlinerTags && d.deal.dealTags.headlinerTags.length > 0) {
            let tagArr = d.deal.dealTags?.headlinerTags.map(ht => ht.name) || [];
            tags = tags.concat(tagArr);
        }
    });
    headlinerTags = [...new Set(tags)].map(ht => {
        return {
            title: ht,
            key: ht,
        }
    }).sort((a, b) => (a.title).localeCompare(b.title)) || []
    
    return (
        <div className="flex overflow-auto md:mr-4">
            {[...tabs, ...headlinerTags].map((t) => (
                <div
                    key={`${t.key}_${t.title}`}
                    className={`text-sm md:text-base px-6 min-w-28 flex justify-center items-center ${activeTab === t.key
                        ? 'bg-[#142C53] text-white cursor-default'
                        : 'bg-[#F1F7FF] text-[#8AA8D8] cursor-pointer'
                        }`}
                    onClick={() => setActiveTab(t.key)}
                >
                    <p className='text-sm text_nowrap font-[WorkSans-Semibold]'>{t.title}</p>
                </div>
            ))}
        </div>
    );
};

export default DealsTabs;
